import React from "react";
import { CpRadio } from "@components";
import {
  useController,
  Control,
  RegisterOptions,
  UseControllerProps,
  FieldValues,
  FieldPath,
} from "react-hook-form";

type CpRadioFieldProps<TFieldValues extends FieldValues = FieldValues> = Omit<
  React.ComponentPropsWithoutRef<typeof CpRadio>,
  "value" | "onChange" | "onBlur" | "error"
> & {
  control: Control<TFieldValues>;
  controllerOptions?: Omit<
    UseControllerProps<TFieldValues>,
    "name" | "control" | "rules"
  >;
  fieldName: FieldPath<TFieldValues>;
  rules?: RegisterOptions<TFieldValues>;
  required?: boolean;
};

export function CpRadioField<TFieldValues extends FieldValues = FieldValues>(
  props: CpRadioFieldProps<TFieldValues>,
) {
  const {
    fieldName,
    control,
    controllerOptions,
    // required, // TODO: Implement required prop
    rules,
    ...cpRadioProps
  } = props;

  const mRules: RegisterOptions<TFieldValues> = {};
  // TODO: Implement required prop
  // if (required) {
  //   mRules.required = "Field is required";
  // }
  const mergedRules = { ...mRules, ...rules };

  const {
    field: { value, onBlur, onChange },
    fieldState: { error },
  } = useController({
    name: fieldName,
    control,
    rules: mergedRules,
    ...controllerOptions,
  });

  return (
    <CpRadio
      {...cpRadioProps}
      value={value}
      onBlur={onBlur}
      onChange={onChange}
      // required={required} // TODO: Implement required prop
      error={error?.message}
    />
  );
}

CpRadioField.Item = CpRadio.Item;
